import { render, staticRenderFns } from "./PrizeDrawSegment.vue?vue&type=template&id=0e2130e0&scoped=true"
import script from "./PrizeDrawSegment.vue?vue&type=script&lang=js"
export * from "./PrizeDrawSegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2130e0",
  null
  
)

export default component.exports